import { render, staticRenderFns } from "./MarketWayText.vue?vue&type=template&id=94bd4962&scoped=true"
import script from "./MarketWayText.vue?vue&type=script&lang=js"
export * from "./MarketWayText.vue?vue&type=script&lang=js"
import style0 from "./MarketWayText.vue?vue&type=style&index=0&id=94bd4962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bd4962",
  null
  
)

export default component.exports